export default "__VITE_ASSET__Bcd4WUdC__"